export default __webpack_public_path__ + "static/media/3.d13287f0.png";